module.exports = __webpack_public_path__ + "assets/img/tx316_2.236a9517.jpg";